module.exports = __webpack_public_path__ + "img/Orchid.30e3dedd.jpg";